// extracted by mini-css-extract-plugin
module.exports = {"youtubeEmbed":"youtubeEmbed_youtubeEmbed__3H1EI"};